import { render, staticRenderFns } from "./LudinamLoader.vue?vue&type=template&id=d10dc710&scoped=true&"
import script from "./LudinamLoader.vue?vue&type=script&lang=js&"
export * from "./LudinamLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10dc710",
  null
  
)

export default component.exports